export function Logo() {
    return (
        <img
            src="/images/logo.png"
            alt="MIMIQ"
            style={{
                width: 36,
                height: 36,
            }}
        />
    );
}
